import { getDefaultSortOrder, Table, Tag, Typography } from "@pankod/refine-antd";
import { useNavigation } from "@pankod/refine-core";
import { ShowUserCard } from "components/profile/showUserCard";
import { displayRelativeDate } from "components/utils/displayRelativeDate";
import { LookupButton } from "components/utils/lookupButton";
import { ICloudScreening, IScreeningMetadata } from "interfaces";
import { RESOURCE_PATH } from "scripts/site";

interface CloudScreeningTableProps {
  metadata: IScreeningMetadata | undefined;
  cloudScreeningData: any;
  sorter: any[];
}

const resourcePath = RESOURCE_PATH.CLOUD_SCREENING;

export const CloudScreeningTable: React.FC<CloudScreeningTableProps> = ({
  cloudScreeningData,
  sorter,
  metadata,
}) => {
  const { show } = useNavigation();

  function rowClick(record: ICloudScreening) {
    return {
      onClick: () => {
        show(resourcePath, record.id);
      },
    };
  }

  return (
    <Table {...cloudScreeningData}
      rowKey="id"
      pagination={{
        ...cloudScreeningData.pagination,
        position: ["bottomRight"],
        showTotal: (total => <Typography.Title level={4} style={{ marginRight: 10 }} >Total {total}</Typography.Title>)
      }}
    >
      {/* Add your table columns here */}
      <Table.Column
        title="Associate"
        dataIndex="associateId"
        key="associateId"
        render={(value) => <ShowUserCard id={value} />}
        onCell={rowClick}
        className="mouseHand"
      />

      <Table.Column
        title="TCS Manager"
        dataIndex="managerUserId"
        key="managerUserId"
        render={(value) => <ShowUserCard id={value} />}
        onCell={rowClick}
        className="mouseHand"
      />

      <Table.Column
        dataIndex="cloudOrganization"
        key="cloudOrganization"
        onCell={rowClick}
        className="mouseHand"
        title="Cloud Organization"
        render={(value, record) => (
          <>
            <Typography.Text
              style={{
                fontWeight: "unset",
                fontSize: "14px",
              }}
            >
              <LookupButton id={record?.cloudOrganizationId} resource={RESOURCE_PATH.CLOUD_ORGANIZATION} noClick></LookupButton>
            </Typography.Text>
            <br />
            <Typography.Text
              style={{
                fontWeight: "unset",
                fontSize: "14px",
              }}
            >
              <LookupButton id={record?.cloudOrganizationGroupId} resource={RESOURCE_PATH.CLOUD_ORGANIZATION_GROUP} noClick></LookupButton>
            </Typography.Text>
          </>
        )}
        sorter
      />

      <Table.Column
        title="Location"
        onCell={rowClick}
        dataIndex="physicalLocationId"
        key="physicalLocationId"
        className="mouseHand"
        sorter
        render={(value) => (
          <LookupButton id={value} resource={RESOURCE_PATH.COUNTRY} noClick />
        )}
      />

      <Table.Column
        dataIndex={["stateManager", "state"]}
        key="stateManager.state"
        title="Status"
        onCell={rowClick}
        className="mouseHand"
        sorter
        render={(value) => {
          if (value) {
            const currentStateMetadata = metadata?.states?.find((state) => state.state === value);
            return (<Tag color={currentStateMetadata?.color ?? "default"}>
              {currentStateMetadata?.displayName ?? value ?? "Loading"}
            </Tag>);
          }
          // <Tag color={fetchStateColor(value)}>{printStateDisplayName(metadata?.states, value)}</Tag>
        }}
      />

      <Table.Column
        dataIndex={["stateManager", "assignedTo"]}
        key="stateManager.assignedTo"
        title="Assigned To"
        onCell={rowClick}
        className="mouseHand"
        render={(value: string[]) =>
          value.length ? value.map((v, i) => (
            <div key={i} style={{ marginBottom: 5 }}>
              <ShowUserCard id={v} />
            </div>
          )) : "None"
        }
      />

      <Table.Column
        dataIndex="updatedAt"
        key="updatedAt"
        title="Last Updated"
        render={displayRelativeDate}
        defaultSortOrder={getDefaultSortOrder("updatedAt", sorter)}
        sorter
        onCell={rowClick}
        className="mouseHand"
      />
    </Table>
  );
};
